export default __webpack_public_path__ + "static/media/tiktok-icon.786911de.svg";